import {Injectable} from '@angular/core';
import {CustomHttp} from '../shared/custom.http';

import 'rxjs/add/operator/toPromise';

import {Router} from '@angular/router';

import {GlobalTrendsRequest} from './globaltrends-request';

@Injectable()
export class GlobalTrendsService {
    private globalTrends = '/globaltrends';  // URL to web api

    constructor(private router: Router, private http: CustomHttp) {
    }

    getGtOverview(gtRequest: GlobalTrendsRequest) {
        return this.http
            .put(this.globalTrends, JSON.stringify(gtRequest));
    }

    createDataSet(gtRequest: GlobalTrendsRequest) {
        return this.http.put(this.globalTrends, JSON.stringify(gtRequest));
    }

    getGtHistorical(gtRequest: GlobalTrendsRequest) {
        return this.http.put(this.globalTrends, JSON.stringify(gtRequest));
    }

    getGeneInfo(type: string) {
        const url = `${this.globalTrends}/badget_info/${type}`;
        return this.http.get(url);
    }

    getGenomeExample(type: string) {
        const url = `${this.globalTrends}/gene_info/${type}`;
        return this.http.get(url);
    }

    getGeneValue(gtRequest: GlobalTrendsRequest) {
        const url = `${this.globalTrends}/genome/`;
        return this.http.put(url, gtRequest);
    }

}


// WEBPACK FOOTER //
// ./src/app/globaltrends/globaltrends.service.ts